// @flow
import type {Feature} from './feature';

export const LEGACY_TIERS = ['TIER_1', 'TIER_2', 'TIER_3', 'TIER_31'];
export const NEW_TIERS = ['TIER_11', 'TIER_22', 'TIER_33'];
export const NEW_NEW_TIERS = [
  'TIER_110',
  'TIER_210',
  'TIER_310',
  'TIER_410',
  'TIER_120',
  'TIER_220',
  'TIER_320',
  'TIER_420',
  'TIER_109',
  'TIER_209',
  'TIER_309',
  'TIER_409',
];
export const FREE_TRIAL_TIERS = ['TIER_109', 'TIER_110', 'TIER_120'];
export const PAID_TIERS = [
  'TIER_3',
  'TIER_309',
  'TIER_310',
  'TIER_320',
  'TIER_409',
  'TIER_410',
  'TIER_420',
];
export const NON_PAID_TIERS = [
  'TIER_11',
  'TIER_22',
  'TIER_109',
  'TIER_110',
  'TIER_120',
  'TIER_209',
  'TIER_210',
  'TIER_220',
];
export const DOWNGRADE_TIERS = [
  'TIER_22',
  'TIER_209',
  'TIER_210',
  'TIER_220',
  'TIER_250',
];
// NEW PLANS
// TRIAL -> 4
export const TRIAL_PLANS = ['TIER_409', 'TIER_410', 'TIER_420'];

export const BASIC_TIERS = ['TIER_309', 'TIER_310', 'TIER_409', 'TIER_410'];
export const PRO_TIERS = ['TIER_120', 'TIER_320', 'TIER_420'];

// RENEWAL TIERS
export const RENEWAL_BASIC_TIERS = ['TIER_309', 'TIER_310'];
export const RENEWAL_PRO_TIERS = ['TIER_320'];
export const RENEWAL_TIERS = [...RENEWAL_BASIC_TIERS, ...RENEWAL_PRO_TIERS];

export const MINIMAL_PLANS = ['TIER_109', 'TIER_309', 'TIER_409'];

export type TierFeatureTier = {
  feature: Feature,
  spec?: {[key: string]: any},
  type: 'tier-feature-tier',
};

export type StoreTier = {
  name: string,
  label: string,
  type: 'store-tier',
  id: string,
};
